import PurchaseStep from './PurchaseStep';
export default PurchaseStep;
